import {
  APP_INITIALIZER,
  EnvironmentProviders,
  makeEnvironmentProviders,
} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  provideTranslateService,
  TranslateLoader,
  TranslateService,
} from '@ngx-translate/core';
import { translateLoaderFactory } from './translate-loader.factory';
import { LanguageService } from './language.service';

function languageInitializer(
  languageService: LanguageService,
  _translate: TranslateService
): () => Promise<unknown> {
  return () => languageService.initWithTranslations();
}

export function provideI18n(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideTranslateService({
      useDefaultLang: true,
      loader: {
        provide: TranslateLoader,
        useFactory: translateLoaderFactory,
        deps: [HttpClient],
      },
    }),
    {
      provide: APP_INITIALIZER,
      useFactory: languageInitializer,
      deps: [LanguageService, TranslateService],
      multi: true,
    },
  ]);
}
